import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const ChannelGroupingsIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_12_795)"><path d="M19.9 12C19.9 16.4 16.3 20 11.9 20C7.49999 20 3.89999 16.4 3.89999 12H19.9Z" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.69998 8H15.9" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" /><path d="M9.69998 4H14" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_12_795"><rect width="18" height="18" fill="white" transform="translate(2.89999 3)" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default ChannelGroupingsIcon;